export default {
  path: '/memberManage',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'memberManage',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
